export default __webpack_public_path__ + "static/media/vilros.e6b0336c.png";